import cloneDeep from "lodash/cloneDeep";
import isEmpty from "lodash/isEmpty";
import store from "../store/store";
import type { FinanceType, UserType } from "../types/userType";
export default class FinanceLogic {
  /**
   * updates finance in user from websockets
   */
  static updateFinance(finance: FinanceType) {
    let user: UserType = cloneDeep(store.getState().userModel.user);

    if (!isEmpty(user.balance)) {
      // Merge new changes
      Object.assign(user.balance, finance);
    } else {
      // add it to the user
      user.balance = finance;
    }

    store.dispatch.userModel.setUser(user);
  }
}
